<template>
  <tbody>
    <tr
      v-for="(client, index) in clientsList"
      :key="index"
    >
      <td class="holder-checkbox w-50">
        <CustomCheckbox
          :id="client.email"
          :label-text="'text'"
          :input-element="client"
        />
      </td>
      <td class="w-200">
        <div
          :id="`goto_client_profile_${generateRandomId(client.publicId)}`"
          class="holder-info name"
          @click="gotoProfile(client.publicId)"
        >
          <div class="info">
            <span v-if="client" class="info-name">
              {{ client.email }}
            </span>
          </div>
        </div>
      </td>
      <td class="w-100">
        <div class="device">
          <div class="mobile-phone">
            <PhoneIcon32 />
          </div>
          <div class="pc">
            <DesktopIcon32 />
          </div>
        </div>
      </td>
      <td class="w-100">
        <span class="registration-date-text">{{ parseDate(client.lastSyncDate) }}</span>
      </td>
      <td class="w-300">
        <div class="holder-btns">
          <button
            :id="`resend_client_${generateRandomId(client.publicId)}`"
            :disabled="!hasPermission(['assign_user_to_case'])"
            class="btn resend-btn"
            @click="resendUserInvite(client)"
          >
            <span class="btn-span">Resend</span>
            <BlueSendIcon19 />
          </button>
          <span
            :id="`disabled-deactivate-client_${generateRandomId(client.publicId)}`"
            :ref="`disabledDeactivateClient_${generateRandomId(client.publicId)}`"
          >
            <button
              :id="`deactivate_client_${generateRandomId(client.publicId)}`"
              :disabled="!hasPermission(['assign_user_to_case'])"
              class="btn btn-deactivate"
              @click.stop="confirmDeactivateUser(client)"
            >
              <span class="btn-span">Remove</span>
              <WhiteCloseIcon20 />
            </button>
          </span>
          <tooltip
            v-if="!hasPermission(['assign_user_to_case'])"
            :target-ref="$refs[`disabledDeactivateClient_${generateRandomId(client.publicId)}`]"
          >
            <span>To be able to remove client from a system - you need to have the 'Assign user to case' permission in system</span>
          </tooltip>
        </div>
      </td>
    </tr>
  </tbody>
</template>

<script>
import hasPermission from '../../../utils/permission';
import CustomCheckbox from '../../inputs/CustomCheckbox';
import parseDate from '../../../mixins/parseDate';
import Tooltip from '@/components/common/Tooltip.vue';
import BlueSendIcon19 from '@/components/icons/BlueSendIcon19.vue';
import WhiteCloseIcon20 from '@/components/icons/WhiteCloseIcon20.vue';
import PhoneIcon32 from '@/components/icons/PhoneIcon32.vue';
import DesktopIcon32 from '@/components/icons/DesktopIcon32.vue';

export default {
  name: 'CaseClientsItem',
  components: {
    DesktopIcon32,
    PhoneIcon32,
    WhiteCloseIcon20,
    BlueSendIcon19,
    Tooltip,
    CustomCheckbox
  },
  mixins: [parseDate],
  props: {
    clientsList: {
      type: Array,
      required: true,
    },
  },
  emits: ['resend', 'confirmDeactivateUser'],
  data() {
    return {
      el: {
        isActive: true
      },
      item: {
        isActive: false
      },
      clientRandomIds: new Map()
    };
  },
  methods: {
    hasPermission,
    generateRandomId(clientPublicId) {
      if (!this.clientRandomIds.has(clientPublicId)) {
        const randomString = Math.random().toString(36).substring(2, 12);
        this.clientRandomIds.set(clientPublicId, randomString);
      }
      return this.clientRandomIds.get(clientPublicId);
    },
    capitalizeFirstLetter(string) {
      if (string) {
        return string[0].toUpperCase() + string.slice(1).toLowerCase();
      }
    },
    gotoProfile(id) {
      let route = this.$router.resolve({name: 'Custodian Profile', params: {slug: id}});
      window.open(route.href, '_blank');
    },
    confirmDeactivateUser(item) {
      this.$emit('confirmDeactivateUser', item);
    },
    resendUserInvite(client) {
      this.$emit('resend', client.publicId, client.email);
    },
  },

};
</script>

<style scoped>

.holder-info.name {
  cursor: pointer;
}

.holder-info.name:hover {
  color: var(--accent-color);
}

.info-name {
  transition: all 0.3s;
}

.info-name:hover {
  color: var(--accent-color);
}

.info {
  width: 100%;
  max-width: calc(100% - 40px);
}

.device {
  width: 100%;
  max-width: 74px;
  display: flex;
  justify-content: space-between;
  margin: 0 64px 0 0;
}

.mobile-phone {
  width: 32px;
  height: 32px;

}

.pc {
  width: 32px;
  height: 32px;
}

.registration-date-text {
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: var(--secondary-text-color);
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
}

.btn-deactivate {
  min-width: 100px;
  width: 146px;
  max-width: 146px;
  min-height: unset;
  padding: 6px 20px;
  font-size: 14px;
  line-height: 14px;
  justify-content: space-between;
  flex-shrink: 1;
  white-space: nowrap;
  box-sizing: border-box;
}

.holder-btns {
  justify-content: flex-end;
  width: 100%;
  max-width: 100%;
  min-width: 300px;
  box-sizing: border-box;
  display: flex;
  transition: all 0.3s ease;
}

.btn-span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 45px;
  max-width: calc(100% - 30px);
  display: inline-block;
}

td:last-child {
  overflow: hidden !important;
  position: relative;
}

td:last-child > * {
  max-width: 100%;
  overflow: hidden;
  box-sizing: border-box;
}

.case-clients-table.non-border .table-row:last-child {
  border-bottom: none;
}

.btn.resend-btn {
  padding: 8px 15px;
  min-width: 90px;
  width: 118px;
  max-width: 118px;
  flex-shrink: 1;
  border-color: var(--case-filters-border-color);
  background-color: var(--white-color);
  font-size: 12px;
  line-height: 14px;
  color: var(--secondary-text-color);
  white-space: nowrap;
  box-sizing: border-box;
}

.btn.resend-btn svg,
.btn-deactivate svg {
  min-width: 19px;
  min-height: 19px;
  flex-shrink: 0;
}

.btn.resend-btn svg path {
  fill: var(--accent-color);
}

.btn.resend-btn:hover {
  color: var(--accent-color);
  border-color: var(--accent-color);
}

.btn.resend-btn:hover svg path {
  fill: var(--accent-color);
}

.resend-btn:disabled {
  color: var(--secondary-text-color) !important;
  border-color: var(--background-button-disabled-color) !important;
  background-color: var(--background-button-disabled-color) !important;
}

.resend-btn:disabled:hover {
  border-color: var(--accent-color) !important;
}

.resend-btn:disabled >>> svg path {
  fill: var(--background-button-disabled-color) !important;
}

</style>
